import React from "react"
import Dialog from "material-ui/Dialog"
import CircularProgress from "material-ui/CircularProgress"
import { Snackbar } from "material-ui"
interface IProps {
    content: string
    autoHideDuration?: number
    close(): void
}

const ProgressSnackbar = (props: IProps) => {
    return props.content === "loading" ?
        <Dialog open={true} style={{ textAlign: "center" }}>
            <span style={{ fontSize: 18, color: "rgb(245, 124, 0)" }}>
                <CircularProgress />
            </span>
        </Dialog> :
        <Snackbar
            open
            bodyStyle={{ maxWidth: null, width: "max-content" }}
            message={props.content}
            autoHideDuration={props.autoHideDuration ? props.autoHideDuration : 5000}
            onRequestClose={props.close}
        />
}

export default ProgressSnackbar
